export const entityTypes = {
  ACTION: "action",
  TASK: "task",
  TASKS: "tasks",
  CRM_TASKS: "crm_tasks",
  PROJECT_TASKS: "project_tasks",
  DEAL: "deal",
  DEALS: "deals",
  CONTACT: "contact",
  CONTACTS: "contacts",
  LEAD: "lead",
  LEADS: "leads",
  COMPANY: "company",
  COMPANIES: "companies",
  CUSTOMER: "customer",
  ENTITY_LIST: "entity_list",
  ENTITY_LIST_VIEW: "entity_list_view",
  SEQUENCE: "sequence",
  SEQUENCE_ENTITY: "sequence_entity",
  CAMPAIGN: "campaign",
  REPLY: "reply",
  MEETING: "meeting",
  MEETING_LOGS: "meeting_logs",
  SIGNAL_STREAM: "signal_stream",
  EMAIL: "email",
  LINKEDIN_LOG: "linkedin_log",
  RESPONSE_LOGS: "response_logs",
  RECOMMENDED_PROMPTS: "recommended_prompts",
  SEQUENCE_EMAILS: "sequence_emails",
  SEQUENCE_LINKEDIN_LOGS: "sequence_linkedin_logs",
  SETUP_SENDER_DETAILS: "setup_sender_details",
  CAMPAIGNS_IN_ENGAGE: "campaigns_in_engage",
  TICKETS: "tickets",
  APPROVALS: "approval_requests",
  PROJECTS: "projects",
  COLLEAGUES: "colleagues",
  EMPLOYEES: "employees",
  VOICE_AGENT: "voice_agent",
  VOICE_AGENT_CAMPAIGN: "voice_agent_campaign",
  VOICE_AGENT_CALL_LOG: "voice_agent_call_log",
  CALL_LOG: "call_log",
  BUSINESS_RECEPTIONIST: "business_receptionist",
  FORM: "form",
  APP_SUBMISSION: "app_submission",
  DIGITAL_EMPLOYEE_SESSION: "digital_employee_session",
  PULL_REQUESTS: "pull_requests",
  COMMITS: "commits",
  ACTION_RUNS: "action_runs",
  ERROR_LOGGING_ISSUES: "error_logging_issues",
  CODE_REVIEWER: "code_reviewer",
  INFERENCE_ROUTER: "inference_router",
  INFERENCE_ROUTER_LOGS: "inference_router_logs",
  SANDBOX: "sandbox",
  ESIGN_AGREEMENT: "esign_agreements",
  ESIGN_TEMPLATE: "template",
  DEPARTMENTS: "departments",
  ONBOARDING: "onboarding",
  OFFBOARDING: "offboarding",
  ATTENDANCE: "attendance",
  HOLIDAYS: "holidays",
  ROLES: "roles",
  SHIFTS: "shift",
};

export const hiddenCRMObjects = [
  entityTypes.TASKS,
  entityTypes.PROJECTS,
  entityTypes.TICKETS,
  entityTypes.DEPARTMENTS,
  entityTypes.ONBOARDING,
  entityTypes.OFFBOARDING,
  entityTypes.ATTENDANCE,
  entityTypes.HOLIDAYS,
  entityTypes.EMPLOYEES,
  entityTypes.ROLES,
  entityTypes.SHIFTS,
];

export const viewEntityMapping = {
  [entityTypes.PROJECTS]: "project",
  [entityTypes.EMPLOYEES]: "employees",
  [entityTypes.VOICE_AGENT]: "voice_agent",
  [entityTypes.VOICE_AGENT_CAMPAIGN]: "voice_agent_campaign",
  [entityTypes.VOICE_AGENT_CALL_LOG]: "voice_agent_call_log",
  [entityTypes.CALL_LOG]: "call_log",
  [entityTypes.BUSINESS_RECEPTIONIST]: "business_receptionist",
};

export const entityTypeToRouteMap = {
  [entityTypes.ACTION]: "/actions",
  [entityTypes.TASK]: "/tasks",
  [entityTypes.DEAL]: "/deals",
  [entityTypes.CONTACT]: "/contacts",
  [entityTypes.LEAD]: "/leads",
  [entityTypes.COMPANY]: "/companies",
  [entityTypes.ENTITY_LIST]: "/list",
};

export const phoneNumberTypes = ["Home", "Mobile", "Work", "Other"];

export const entityDetailsMessage = {
  contact_details: {
    page: "Contact",
    content: "to lead details ",
    route: "/contacts/",
  },
  lead_details: {
    page: "Lead",
    content: "to contact details ",
    route: "/leads/",
  },
};

export const entityTypeDisplay = {
  [entityTypes.CONTACT]: { singular: "contact", plural: "contacts" },
  [entityTypes.LEAD]: { singular: "lead", plural: "leads" },
  [entityTypes.COMPANY]: { singular: "company", plural: "companies" },
  [entityTypes.DEAL]: { singular: "deal", plural: "deals" },
  [entityTypes.SEQUENCE]: { singular: "sequence", plural: "sequences" },
  [entityTypes.ENTITY_LIST]: { singular: "list", plural: "lists" },
  [entityTypes.COLLEAGUES]: { singular: "colleague", plural: "colleagues" },
  [entityTypes.EMPLOYEES]: { singular: "employee", plural: "employees" },
  [entityTypes.VOICE_AGENT]: {
    singular: "voice agent",
    plural: "voice agents",
  },
  [entityTypes.VOICE_AGENT_CAMPAIGN]: {
    singular: "voice agent campaign",
    plural: "voice agent campaigns",
  },
  default: { singular: "entity", plural: "entities" },
};
